import get from 'lodash/get';
import isArray from 'lodash/isArray';

import {
  createReqConsts,
  createActions,
  createReqWatcher,
  makePaginationReducer,
} from '../../../utils/redux';
import { consts as SIGN_CONSENT_APPOINTMENT } from './sign-appointment-consent-req';
import { TODO_TYPES } from '../../../constants';

const requestOptions = {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'healthboard',
    'scheduled_tasks',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

export const consts = createReqConsts('health-board', 'scheduled-tasks-req', [
  'LOAD_MORE',
  'TOGGLE_VISIBILITY',
  'REMOVE_ENTITY',
  'UPDATE_INSURANCE_CARD_FOR_TO_DO_TASK',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export const paginationConsts = createReqConsts(
  'health-board',
  'scheduled-tasks-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
  true,
);

const reducer = makePaginationReducer({
  consts,
  paginationConsts,
  counterKey: 'tasksCount',
});

export default (state, action) => {
  switch (action.type) {
    case consts.TOGGLE_VISIBILITY: {
      const { type, id, matchParam = 'id', visible } = action.payload;
      const count = visible ? state.count + 1 : state.count - 1;
      const list = state.list.map(item => {
        if (item.type === type && item.payload[matchParam] === id) {
          return {
            ...item,
            payload: {
              ...item.payload,
              hidden: !visible,
            },
          };
        }

        return item;
      });

      return {
        ...state,
        list,
        count: count >= 0 ? count : 0,
      };
    }

    case SIGN_CONSENT_APPOINTMENT.SUCCEED: {
      const { appointmentConsentId } = action.payload;

      let { count } = state;
      const list = state.list
        ? state.list.reduce((acc, task) => {
            if (task.type === TODO_TYPES.CONSENT) {
              let consents = get(task, 'payload.consents');

              if (!consents || !isArray(consents)) return task;

              consents = consents.filter(
                ({ id }) => id !== appointmentConsentId,
              );

              if (consents.length === 0) {
                count -= 1;
                return acc;
              }

              return [
                ...acc,
                {
                  ...task,
                  payload: {
                    ...task.payload,
                    consents,
                  },
                },
              ];
            }

            return [...acc, task];
          }, [])
        : [];

      const filteredList = list.filter(listItem => {
        if (listItem.type === TODO_TYPES.CONSENT_USER_ASSIGNMENT) {
          const removedConsentId = get(listItem, 'payload.consent.id');

          if (appointmentConsentId === removedConsentId) {
            count -= 1;
            return false;
          }

          return true;
        }

        return true;
      });

      return {
        ...state,
        count: count >= 0 ? count : 0,
        list: filteredList,
      };
    }

    case consts.REMOVE_ENTITY: {
      const { type, id, matchParam = 'id', keepCount } = action.payload;
      const count = keepCount ? state.count : state.count - 1;
      const list = state.list.filter(task => {
        if (task.type === type) {
          return task.payload[matchParam] !== id;
        }
        return true;
      });

      return {
        ...state,
        count: count >= 0 ? count : 0,
        list,
      };
    }

    case consts.UPDATE_INSURANCE_CARD_FOR_TO_DO_TASK: {
      const { payload } = action;

      const list = state.list.map(item => {
        if (
          'patientInsurance' in item.payload &&
          'id' in item.payload.patientInsurance &&
          item.payload.patientInsurance.id === payload.id
        ) {
          return {
            ...item,
            payload: {
              ...item.payload,
              patientInsurance: {
                ...item.payload.patientInsurance,
                ...payload,
              },
            },
          };
        }

        return item;
      });

      return { ...state, list };
    }

    default:
      return reducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/scheduled-tasks-upcoming-req.js